var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3811 17.6548C14.7532 17.6548 18.2974 14.1106 18.2974 9.73855C18.2974 5.36651 14.7532 1.82227 10.3811 1.82227C6.00908 1.82227 2.46484 5.36651 2.46484 9.73855C2.46484 14.1106 6.00908 17.6548 10.3811 17.6548Z",
    fill: "#FFC943",
    stroke: "#4F4C46",
    strokeWidth: 0.791628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3809 6.57227V12.9053",
    stroke: "#4F4C46",
    strokeWidth: 0.791628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21484 9.73828H13.5479",
    stroke: "#4F4C46",
    strokeWidth: 0.791628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFeatures);
export default __webpack_public_path__ + "static/media/add-features.d0707706c72444d04329c1eee02d4082.svg";
export { ForwardRef as ReactComponent };